const selectors = {
  template: {
    container: '#resource-collection-modal-container-template',
    form: '#resource-collection-modal-form-template',
    cart: '#resource-collection-modal-cart-template',
    item: '#resource-collection-modal-cart-item-template',
  },
  cart: {
    wrapper: '.vtc-cart-collection-app',
    empty: '.vtc-empty-cart-wrapper',
    folder: '.header-download',
    error: {
      slug: 'vtc-cart-search__error-message',
      class: '.vtc-cart-search__error-message',
    },
    actions: {
      wrapper: '.vtc-cart-collection-actions',
      download: '.bbm-modal__button.download',
      remove: '.bbm-modal__button.remove',
      all: '#vtc-cart-collection-all',
    },
  },
  search: {
    wrapper: '#vtc-cart-search',
    resources: {
      wrapper: 'vtc-cart-search__resources-wrapper',
    },
    dropdown: {
      slug: 'resources-search-dropdown',
      id: '#resources-search-dropdown',
    },
    input: '#resources-search-input',
    form: '.vtc-cart__search-form',
  },
  icons: {
		loading: 'icon-search-victaulic-orange icon-loading icon-spin',
		mdiLoading: 'mdi-magnify mdi-loading mdi-spin',
	},
  table: {
    table: '.vtc-cart-collection-table',
    content: '#vtc-cart-collection-table-content',
    container: 'table.vtc-resources',
		cell: '.js-vtc-resource-table-toggle-cell-panel',
		popup: '.vtc-resource-table-actions-popup',
    lang: {
      toggle: '.js-resource-lang-toggle',
    },
    action: '.vtc-action',
    body: '.vtc-cart-collection-table tbody',
    reorder: '.vtc-resource-reorder-zone',
    check: '.vtc-cart-collection-check',
  },
  form: {
    wrapper: '.js-vtc-resource-cart-form',
    clone: '#vtc-resource-cart-form-clone',
    spinner: '.gform_ajax_spinner',
    gfWrapper: '.gform_wrapper',
    hiddenInput: 'input.gform_hidden',
    status: '.vtc-download-status-container',
    text: '.vtc-cart__section.form-wrapper .col.form-text',
    confirmation: '.gform_confirmation_message',
  },
  resources: {
    selected: '.vtc-resource-selected:checked',
    checked: '.vtc-resource-selected.vtc-action:checked',
    actions: {
      add: '.js-resource-table-add-group-to-collection',
      all: '#vtc-cart-collection-all',
    },
    links: {
      container: '.vtc-resource-collection',
      link: '.vtc-resource-link',
    },
  },
};

export default selectors;
